export default "__VITE_ASSET__BMR7xpGq__"